﻿import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';


@Directive({
    selector: '[DisableIfUnauthorized]'
})
export class DisableIfUnauthorizedDirective implements OnInit {
    @Input('DisableIfUnauthorized') permission: number; // Required permission passed in
    @Input('FunctionId') functionid: string;
    constructor(private el: ElementRef, private authorizationService: AuthorizationService) { }
    ngOnInit() {
        if (!this.authorizationService.hasPermission(this.permission, this.functionid)) {
            this.el.nativeElement.disabled = true;
        }
    }
}